import { Table, Button, Row, Col, Space } from 'antd/lib';
import * as Icons from '@ant-design/icons';
import React from 'react';
import moment from 'moment';
import _ from 'lodash';

class TablaDocumentos extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filterDropdownVisible: false,
      verFiltroApellido: false,
      verFiltroTipo: false,
      data: this.props.certificaciones,
      textoBuscarNombre: props.textoFiltroNombre ? props.textoFiltroNombre : '',
      textoBuscarApellido: props.textoFiltroApellido
        ? props.textoFiltroApellido
        : '',
      textoBuscarDocumento: props.textoFiltroDocumento
        ? props.textoFiltroDocumento
        : '',
      textoBuscarTipo: props.textoFiltroTipo ? props.textoFiltroTipo : '',
      filtered: false,
    };
  }

  onInputChange = e => {
    this.setState({ textoBuscarNombre: e.target.value });
  };

  onApellidoChange = e => {
    this.setState({ textoBuscarApellido: e.target.value });
  };

  onDocumentoChange = e => {
    this.setState({ textoBuscarDocumento: e.target.value });
  };
  onTipoChange = e => {
    this.setState({ textoBuscarTipo: e.target.value });
  };

  descargar = () => {
    this.props.onDescargar();
  };

  render() {
    const columns = [
      {
        title: 'Titulo',
        dataIndex: 'nombre',
        key: 'titulo',
        render: titulo => titulo.toUpperCase(),
      },
      {
        title: 'Ult. Modif.',
        key: 'fechaModificacion',
        render: documento =>
          documento.fechaModificacion
            ? moment(documento.fechaModificacion).format('DD/MM/YYYY HH:mm')
            : moment(documento.fechaCreacion).format('DD/MM/YYYY HH:mm'),
      },
      {
        title: 'Estado',
        key: 'Estado',
        render: documento => _.defaultTo(documento.estado, 'BORRADOR'),
      },
      {
        title: 'Firma Digital',
        key: 'firmaDigital',
        render: documento => (documento.firmadoDigitalmente ? 'SI' : 'NO'),
      },
      {
        title: 'Acciones',
        key: 'acciones',
        render: (text, record) => (
          <Space>
            <Button
              type="primary"
              disabled={!record.textoHtml && !record.modificable}
              onClick={() =>
                this.props.history.push(`/documento/editar/${record._id}`)
              }
              icon={<Icons.EditOutlined />}
            />
            {record.pdfBase64 && (
              <Button
                disabled={
                  !(record.tipo === 'DOCUMENTO DIGITAL') || !record.pdfBase64
                }
                onClick={() =>
                  this.props.verPdf(
                    record.pdfBase64,
                    `Documento_Num_${record.nombre}_${record._id}`
                  )
                }
                icon={<Icons.DownloadOutlined />}
              />
            )}
            {!(record.tipo === 'DOCUMENTO DIGITAL') && (
              <Button
                onClick={() => this.props.confirmarDocumento(record._id)}
                icon={<Icons.CheckOutlined />}
              />
            )}
            <Button
              onClick={() => this.props.mostrarModalMandarEmail(record._id)}
              icon={
                <Icons.MailOutlined
                  style={{
                    color: record.enviadoPorEmail ? '#27b504' : '#000000',
                  }}
                />
              }
            />
            <Button
              onClick={() => this.props.mostrarModalVisorEmail(record._id)}
              icon={<Icons.SearchOutlined />}
            />
            <Button
              type="danger"
              icon={<Icons.CloseCircleOutlined />}
              onClick={() => this.props.eliminarDocumento(record._id)}
            />
          </Space>
        ),
      },
    ];
    const { documentos } = this.props;
    return (
      <Table
        rowKey="_id"
        columns={columns}
        size="middle"
        dataSource={documentos}
        pagination={false}
        loading={this.props.loadingTabla}
        title={() => (
          <div>
            <h2 style={{ textAlign: 'center' }}> Documentos</h2>
            <div style={{ textAlign: 'center' }}>
              <Row>
                <Col span={6}>
                  Cantidad Total de Documentos: {this.props.total}
                </Col>
              </Row>
            </div>
          </div>
        )}
        locale={{
          emptyText: 'Sin documentos cargados.',
        }}
      />
    );
  }
}

export default TablaDocumentos;
